import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SelectBoxDefault from "../SearchSelectBox/SelectBoxDefault";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getStaff } from "../../api/user";
import AvatarSelectBoxDefault from "../SearchSelectBox/AvatarSelectBoxDefault";

const AvatarOwnerSelectBox = (props:any) => {
    const { value, manageSelect, dataLabel, hideLabel, manageOnBlur, isReadOnly, ml, width } = props;
    const [inputValue, setInputValue] = React.useState('');
    const [selectedAvatarPath, setSelectedAvatarPath] = React.useState('');
    const [optionList, setOptionList] = useState([]);
    const [t] = useTranslation();
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);

    const manageHandleChange = (_event: any, newValue: any) => {
      let tempObj:any = Object;
      
      if (newValue == null || newValue == undefined) {
        tempObj = dataLabel ? {ownerName: null, [dataLabel]: null} : {ownerName: null, ownerId: null};
      } else {
        tempObj = dataLabel ? {ownerName: newValue.displayName, [dataLabel]: newValue.id, departmentId: newValue.departmentId} : {ownerName: newValue.displayName, ownerId: newValue.id, departmentId: newValue.departmentId};
      }
      manageSelect(tempObj);
    };
  
    const manageHandleInputChange = (_event: any, newInputValue: string) => {
      (newInputValue != undefined || newInputValue != 'undefined') &&
      setInputValue(newInputValue);
      // setOptionList(optionList);
    };

    const fetchStaffList = async () => {
      const response = await getStaff(!isAdmin && { clubId: clubDetails?.id });
      setOptionList(response);
      const selectedObj = response?.find((item:any) => item.id == value);
      setInputValue(selectedObj ? (selectedObj?.displayName || '') : '');
      setSelectedAvatarPath(selectedObj ? selectedObj?.avatarPath : '');
    }
    useEffect(() => {
      ((clubDetails && clubDetails?.id && !isAdmin) || isAdmin)  &&
      fetchStaffList();
    }, [value]);

    return (
      <Box sx={{ display: "flex", ml: ml ? ml : "auto"}}>
        {
          !hideLabel &&
          <Typography className="fs12 fw700 mtbAuto">{t('OWNER')}</Typography>
        }
        <Box sx={{ width: width ? width : '120px', ml: '5px' }} className={'mtbAuto'} onBlur={manageOnBlur}>
          <AvatarSelectBoxDefault
          options={optionList}
          keyLabel={'displayName'}
          handleChange={manageHandleChange}
          variant={'standard'}
          selectedValue={value}
          handleInputChange={manageHandleInputChange}
          inputValue={inputValue}
          selectedAvatarPath={selectedAvatarPath}
          isReadOnly={isReadOnly}
          />
        </Box>
      </Box>
    )
}

export default AvatarOwnerSelectBox;